/* eslint-disable */
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import '~styles/modules/twocolformat.scss';

const twoColFormat = ({ data }) => {

  //Build image
  const image = data.map((item) => {

    //If it's archieJSON we know it's the archie part of our combo, otherwise it's teh body element (in this case always text)
    if (item.archieJson){
      const archieObj = JSON.parse(item.archieJson)
      return (
            <div className="col-images">
              <a href={archieObj.url}><img src={archieObj.image} /></a>
            </div>
      )

    }
  });

  //Build title
  const title = data.map((item) => {

    //If it's archieJSON we know it's the archie part of our combo, otherwise it's teh body element (in this case always text)
    if (item.archieJson){
      const archieObj = JSON.parse(item.archieJson)
      return (
        <h2 className="two-col-titles col-titles"><a href={archieObj.url}>{archieObj.title}</a></h2>
      )

    };
    
  });

  //Build description
  const description = data.map((item) => {
    if (!item.archieJson){
      if (item.type=='text'){
        return (
          <p className="paragraph">
            {ReactHtmlParser(item.content)}
          </p>
        )
      }
    }
  });

  //Combine
  return (
    <div className="two-col-entry-containers">
      <div className="two-col-image-containers">
        {image}
      </div>
      <div className="two-col-text-description">
        {title}
        {description}
      </div>
    </div>


  );
};

export default twoColFormat;
